// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-width[data-v-c87050a0] {\n  width: 94%;\n  margin: 0 auto;\n  padding-bottom: 90px;\n}\n[data-v-c87050a0] .confirm_wrapper {\n  z-index: 999999 !important;\n}", ""]);
// Exports
module.exports = exports;
